import React, { useState, createRef, forwardRef, useEffect } from 'react'
import { Waypoint } from 'react-waypoint'
import { Wrapper } from './style.css'

import Item from './Item'
import AllItems from './AllItems'

const ItemWithRef = forwardRef((props, ref) => {
  return <Item innerRef={ref} {...props} />
})

const AllItemsWithRef = forwardRef((props, ref) => {
  return <AllItems innerRef={ref} {...props} />
})

const Scroller = ({
  trimestres,
  allVisibles,
  allComunasAfectadas,
  onVisible,
  onAllVisible,
  comunasAfectadas,
  triggerMapChange,
  triggerMapChangeAll,
  resetMapView,
  onTriggerMapAll,
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    console.log('open!!', open)
  }, [open])

  const onTriggerMapChange = node => {
    // console.log('trigger on scroller yo', node)
    triggerMapChange(node)
  }

  const onTriggerMapChangeAll = node => {
    // console.log('trigger on scroller yo', node)
    triggerMapChangeAll(node)
  }

  return (
    <Wrapper>
      {trimestres &&
        Object.keys(trimestres).map(trimestre => {
          return (
            <Waypoint key={trimestre} onEnter={() => onVisible(trimestre)}>
              <ItemWithRef
                trimestres={trimestres}
                trimestre={trimestre}
                comunasAfectadas={comunasAfectadas}
                triggerMapChange={onTriggerMapChange}
                resetMapView={resetMapView}
              />
            </Waypoint>
          )
        })}
      <Waypoint
        key="last"
        onEnter={() => {
          onAllVisible()
          onTriggerMapAll()
        }}>
        <AllItemsWithRef
          allVisibles={allVisibles}
          comunasAfectadas={allComunasAfectadas}
          titulo={'Todos los incidentes 2015-2021'}
          triggerMapChangeAll={onTriggerMapChangeAll}
          resetMapView={resetMapView}
        />
      </Waypoint>
    </Wrapper>
  )
}

export default Scroller
